export interface Category {
  kanji: string;
  label: string;
  icon: string;
  to: string;
}

export const categories: Category[] = [
  { kanji: '挨拶', label: 'Greetings', icon: '🙋‍♂️', to: '/greetings' },
  { kanji: '食事', label: 'Restaurant', icon: '🍣', to: '/restaurants' },
  { kanji: '映画', label: 'Movies', icon: '🎬', to: '/movies' },
  { kanji: '駅舎', label: 'Train Station', icon: '🚉', to: '/train-station' },
  { kanji: '買物', label: 'Shopping', icon: '🛒', to: '/shopping' },
  { kanji: '旅行', label: 'Travel', icon: '✈️', to: '/travel' },
  { kanji: '緊急', label: 'Emergency', icon: '🚨', to: '/emergency' },
  { kanji: '交流', label: 'Socialising', icon: '🗣️', to: '/socialising' },
];
